<template>
	<div class="small-12 contentLoader flex justify-center" v-if="!loaded">
		<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; display: block;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
			<circle cx="50" cy="50" r="33.0043" fill="none" stroke="#44c6f6" stroke-width="2">
			  <animate attributeName="r" repeatCount="indefinite" dur="1.9607843137254901s" values="0;40" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="-0.9803921568627451s"></animate>
			  <animate attributeName="opacity" repeatCount="indefinite" dur="1.9607843137254901s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="-0.9803921568627451s"></animate>
			</circle>
			<circle cx="50" cy="50" r="13.2168" fill="none" stroke="#44c6f6" stroke-width="2">
			  <animate attributeName="r" repeatCount="indefinite" dur="1.9607843137254901s" values="0;40" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline"></animate>
			  <animate attributeName="opacity" repeatCount="indefinite" dur="1.9607843137254901s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline"></animate>
			</circle>
		</svg>
	</div>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'LoadingSpinner',

		/*
		** Set the props
		*/

		props: {

			loaded: {
				type: Boolean,
				default: false
			}

		}

	}

</script>